import { createSelector } from '@ngrx/store';

import { membersState } from '../root';

/** Checks if member is fully authorized and signed in. This should be used for all main checks except account activation scenario */
export const isMemberAuthorizedJWT = createSelector(membersState, (members) => (members?.isAuthorized && members?.jwt.hasSucceeded) || false);
